<template>
    <v-container fluid class="black py-0" :class="{'isCheckout': isCheckout}">
        <top-banner v-if="!isCheckout" />
        <MainHeader :isCheckout="isCheckout" />
        <Menu v-if="!isCheckout" />
    </v-container>
</template>

<script>
    import MainHeader from "../Header/MainHeader";
    import Menu from '../Header/Menu'
    import TopBanner from "../Header/TopBanner";

    export default {
        name: 'NavBar',
        props: ['isCheckout'],
        components: {
            MainHeader,
            Menu,
            TopBanner
        }
    }
</script>
